<template>
    <div class="sidebar-footer">
        <div @click="isShowLogout = !isShowLogout" :class="['footer-content', { 'h-20 bg-zinc-200': isShowLogout }]">
            <div class="user">
                <PersonAvatar :name="store.person?.name" :person_id="store.person?.id!" :width="32" :height="32" />
                <span>{{ store.person?.name }}</span>
            </div>
            <svg v-if="isShowLogout" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M20.0307 15.5306C19.961 15.6003 19.8783 15.6557 19.7873 15.6934C19.6962 15.7311 19.5986 15.7506 19.5001 15.7506C19.4015 15.7506 19.3039 15.7311 19.2128 15.6934C19.1218 15.6557 19.0391 15.6003 18.9694 15.5306L12.0001 8.56029L5.03068 15.5306C4.88995 15.6713 4.69907 15.7504 4.50005 15.7504C4.30103 15.7504 4.11016 15.6713 3.96943 15.5306C3.8287 15.3899 3.74963 15.199 3.74963 15C3.74963 14.801 3.8287 14.6101 3.96943 14.4694L11.4694 6.96935C11.5391 6.89962 11.6218 6.8443 11.7128 6.80656C11.8039 6.76882 11.9015 6.74939 12.0001 6.74939C12.0986 6.74939 12.1962 6.76882 12.2873 6.80656C12.3783 6.8443 12.461 6.89962 12.5307 6.96935L20.0307 14.4694C20.1004 14.539 20.1557 14.6217 20.1935 14.7128C20.2312 14.8038 20.2506 14.9014 20.2506 15C20.2506 15.0985 20.2312 15.1961 20.1935 15.2872C20.1557 15.3782 20.1004 15.4609 20.0307 15.5306Z"
                    fill="#343330"
                />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M20.0306 9.53062L12.5306 17.0306C12.4609 17.1003 12.3782 17.1557 12.2871 17.1934C12.1961 17.2312 12.0985 17.2506 11.9999 17.2506C11.9014 17.2506 11.8038 17.2312 11.7127 17.1934C11.6217 17.1557 11.539 17.1003 11.4693 17.0306L3.9693 9.53062C3.82857 9.38988 3.74951 9.19901 3.74951 8.99999C3.74951 8.80097 3.82857 8.61009 3.9693 8.46936C4.11003 8.32863 4.30091 8.24957 4.49993 8.24957C4.69895 8.24957 4.88982 8.32863 5.03055 8.46936L11.9999 15.4397L18.9693 8.46936C19.039 8.39968 19.1217 8.34441 19.2128 8.30669C19.3038 8.26898 19.4014 8.24957 19.4999 8.24957C19.5985 8.24957 19.6961 8.26898 19.7871 8.30669C19.8781 8.34441 19.9609 8.39968 20.0306 8.46936C20.1002 8.53905 20.1555 8.62177 20.1932 8.71282C20.2309 8.80386 20.2503 8.90144 20.2503 8.99999C20.2503 9.09854 20.2309 9.19612 20.1932 9.28716C20.1555 9.37821 20.1002 9.46093 20.0306 9.53062Z"
                    fill="#343330"
                />
            </svg>
        </div>
        <div @click="handleShowLogout" v-if="isShowLogout" class="logout">
            <div class="icon-logout">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M11.25 20.25C11.25 20.4489 11.171 20.6397 11.0303 20.7803C10.8897 20.921 10.6989 21 10.5 21H4.5C4.30109 21 4.11032 20.921 3.96967 20.7803C3.82902 20.6397 3.75 20.4489 3.75 20.25V3.75C3.75 3.55109 3.82902 3.36032 3.96967 3.21967C4.11032 3.07902 4.30109 3 4.5 3H10.5C10.6989 3 10.8897 3.07902 11.0303 3.21967C11.171 3.36032 11.25 3.55109 11.25 3.75C11.25 3.94891 11.171 4.13968 11.0303 4.28033C10.8897 4.42098 10.6989 4.5 10.5 4.5H5.25V19.5H10.5C10.6989 19.5 10.8897 19.579 11.0303 19.7197C11.171 19.8603 11.25 20.0511 11.25 20.25ZM21.5306 11.4694L17.7806 7.71937C17.6399 7.57864 17.449 7.49958 17.25 7.49958C17.051 7.49958 16.8601 7.57864 16.7194 7.71937C16.5786 7.86011 16.4996 8.05098 16.4996 8.25C16.4996 8.44902 16.5786 8.63989 16.7194 8.78063L19.1897 11.25H10.5C10.3011 11.25 10.1103 11.329 9.96967 11.4697C9.82902 11.6103 9.75 11.8011 9.75 12C9.75 12.1989 9.82902 12.3897 9.96967 12.5303C10.1103 12.671 10.3011 12.75 10.5 12.75H19.1897L16.7194 15.2194C16.5786 15.3601 16.4996 15.551 16.4996 15.75C16.4996 15.949 16.5786 16.1399 16.7194 16.2806C16.8601 16.4214 17.051 16.5004 17.25 16.5004C17.449 16.5004 17.6399 16.4214 17.7806 16.2806L21.5306 12.5306C21.6004 12.461 21.6557 12.3783 21.6934 12.2872C21.7312 12.1962 21.7506 12.0986 21.7506 12C21.7506 11.9014 21.7312 11.8038 21.6934 11.7128C21.6557 11.6217 21.6004 11.539 21.5306 11.4694Z"
                        fill="#09090B"
                    />
                </svg>
                <span>Logout</span>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import PersonAvatar from '~/components/main/shared/PersonAvatar.vue';
import { useDynamicDialog } from '~/composables/dynamic-dialog';
import { ModalNames } from '~/types/modals';

const store = usePersonStore();

const isShowLogout = ref(false);

const handleShowLogout = () => {
    useDynamicDialog(ModalNames.ADMIN_LOGOUT);
};
</script>
<style scoped lang="scss">
.sidebar-footer {
    @apply flex flex-col justify-center items-center py-3 px-3 w-full cursor-pointer border-t border-border-gray;

    .logout {
        @apply flex items-center gap-3 self-stretch py-3 px-3.5 transition-all duration-300;

        &:hover {
            transform: translateX(10px);

            .icon-logout span {
                @apply text-red-400;
            }

            svg path {
                fill: #f87171; 
            }
        }

        .icon-logout {
            @apply flex items-center gap-3 flex-1;
        }

        span {
            @apply text-zinc-950 font-inter text-sm font-semibold leading-normal;
        }
    }

    .footer-content {
        @apply flex items-center gap-3 self-stretch py-3 px-3.5 transition-all duration-300;

        &:hover {
            transform: translateY(-5px);

            .user span {
                @apply text-amber-400;
            }

            svg path {
                fill: #fbbf24; 
            }
        }

        .user {
            @apply flex items-center gap-3 flex-1;

            span {
                @apply flex items-center gap-3 flex-1 text-sm font-medium font-inter leading-normal text-zinc-950;
            }
        }
    }
}
</style>
